<template>
<div class="rule-wrap">
    <div class="rule">
        <div class="nav clearfix">
            <router-link to='/makeMoney'>
                <img class="navBack pull-left" src="../../../static/images/shootShop/back.png" alt="">
            </router-link>
            <h2 class="navTitle pull-left">奖励规则及攻略</h2>
        </div>
        <div class="rule-main">
            <h2>一、奖励规则</h2>
            <div>
                <h3>
                    <span>1、奖励认定：</span>
                    每一个正在出租/转让的店铺代表一单，审核通过即可发放奖励。
                </h3>
                <h4>2、奖励标准</h4>
                <h5 v-if="this.isShow == '0'">(1)&nbsp;基本奖励</h5>
                <div v-if="this.appCityId == '110100' || this.bjCityId == '110100' ||  this.appCityId == '1' || this.bjCityId == '1'" >
                		<p>北京地区五环内有效商铺{{this.base_bonus_1}}元/套，北京地区五环外有效商铺{{this.base_bonus_2}}元/套</p>
                </div>
                <div v-else> <p>市区审核通过：{{this.base_bonus_1}}元/个, 郊区审核通过：{{this.base_bonus_2}}元/个</p></div>
            </div>
            <h2>二、发布规则</h2>
            <div>
                <p>1、拍照要求：拍摄正规底商、有商铺门头展示面。如非正规商铺，则审核失败。</p>
				<p>2、定位要求：禁止拍照后，多个商铺租赁信息批量上传。由于上传时候会自动获取当前定位，如定位不对，则审核失败。</p>
				<p>3、图片要求：上传图片必须为正面门头照、商铺左侧展示图、商铺右侧展示图、贴有出租转让电话图。如未按照拍店示例上传图片，则审核失败。【详见“租铺宝”App拍店赚钱功能的拍店示例】</p>
				<p>4、电话要求：手动输入店铺租赁的电话号码，有监测重复机制，重复的号码，无法上传。如手动输入号码与上传第四张图片上的电话不符合，则审核失败。</p>
				<p>5、一铺多人：同一个商铺或电话，有多个电话或商铺情况，仅能上传一次，不可重复换号码上传，否则发现后，审核失败。</p>
                
                <p>当日拍摄商铺48小时内审核完毕，拍店人可通过“租铺宝”APP—拍店赚钱—拍店记录查看审核中、已通过和未通过信息。</p>
            </div>
            <h2>三、本手册的最终解释权归优铺所有。</h2>
        </div>
    </div>
</div>
</template>
<script>
import $ from '../../../static/js/jquery.min.js';
import axios from 'axios';
import qs from 'qs';
export default {
    name: 'seekShop',
    data () {
        return {
            move: "",
            appCityId: "",
            bjCityId: "",
            base_bonus_1: "",
            base_bonus_2: "", //基本奖励(5环外/郊区)
            extra_bonus_1: "", //额外奖励 超过5个
            extra_bonus_2: "",//额外奖励 超过10个
            extra_bonus_3: "", //额外奖励 超过15及以上

            isShow: "0", //是否显示额外奖励

        }
    },
    computed:{

    },
    updated(){

    },
    methods:{
        // 获取价格信息
        priceData(){
            // 接口调用
            let _this = this;
            let url = _this.changeData() + '/photo/getPhotoRules'
            axios(url,{
                method: 'post',
                params: {
                    cityId: this.appCityId || sessionStorage.cityId // 市id
                }
            }).then(data => {
                // console.log(data);
                // this.vipArr = data.data.productList;
                this.base_bonus_1 = data.data.data.base_bonus_1; // 基本奖励(5环内/市区)
                this.base_bonus_2 = data.data.data.base_bonus_2; // 基本奖励(5环外/郊区)
                this.extra_bonus_1 = data.data.data.extra_bonus_1; // 额外奖励 超过5个
                this.extra_bonus_2 = data.data.data.extra_bonus_2; // 额外奖励 超过10个
                this.extra_bonus_3 =  data.data.data.extra_bonus_3;// 额外奖励 超过15及以上

            }).catch(err => {
                console.log(err)
            });
        }
    },
    mounted() {
        //截取Url里面的参数
        function GetRequest() {
            var url = location.search; //获取url中"?"符后的字串
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                var str = url.substr(1);
                var strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
                }
            }
            return theRequest;
        }
        var request = new Object();
        request = GetRequest();

        this.move = request['move'];
        this.appCityId = request['cityId'];

        this.bjCityId = sessionStorage.cityId;

        if(this.move == "ios"){
            $(".nav").hide();
        }else if(this.move == "android"){
            $(".nav").hide();
            $(".rule").css("padding","0");
        }

        if(sessionStorage.cityId == "110100" || sessionStorage.cityId == "120100" || this.appCityId == "110100" || this.appCityId == "120100"){
            this.isShow = "0";
        }else{
            this.isShow = "1";
        }

        // if(sessionStorage.cityId == "120100" || this.appCityId == "120100"){
        //     this.isShow = "0";
        // }else{
        //     this.isShow = "1";
        // }

        this.priceData();

    }
}
</script>

<style scoped lang="scss">
/*浮动*/
.pull-right{
    float: right;
}
.pull-left{
    float: left;
}
.clearfix:after {
    content: " ";
    display: block;
    clear: both;
    height: 0;
}
.clearfix {
    zoom: 1;
}

input::-webkit-input-placeholder{
    color:#fff;
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color:#fff;
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color:#fff;
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color:#fff;
}
/*内容部分*/
.rule-wrap{
    width: 7.5rem;
    margin: 0 auto;
    background: #fff;
}
.rule{
    width: 7.5rem;
    margin: 0 auto;
    background: #fff;
    padding-top: .88rem;
    padding-bottom: .3rem;
}
.nav{
    width: 6.9rem;
    height: .88rem;
    background: #fff;
    margin: 0 auto;
    padding:  0 0.3rem;
    position: fixed;
    top: 0;
    z-index: 99;
}
.nav a{
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}
.navBack{
    width: 0.2rem;
    height: 0.36rem;
    margin-top: 0.26rem;
}
.navTitle{
    height: .88rem;
    width: 6.4rem;
    line-height: .88rem;
    font-size: 0.36rem;
    color: #3c3c3c;
    text-align: center;
}
.rule-main{
    width: 6.9rem;
    padding: 0 .3rem;
    color: #363636;
    h2{
        padding: .5rem 0;
        color: #363636;
        font-size: .32rem;
        font-weight: 500;
    }
    div{
        h3{
            font-size: .28rem;
            color: #363636;
            span{
                font-weight:500;
            }
        }
        h4{
            font-size: .28rem;
            color: #363636;
            line-height: .44rem;
            margin: .2rem 0 .1rem;
        }
        h5{
            font-size: .28rem;
            color: #363636;
            line-height: .44rem;
            margin: .1rem 0;
        }
        h6{
            font-size: .24rem;
            color: #363636;
            line-height: .44rem;
        }
        p{
            font-size: .28rem;
            color: #363636;
            line-height: .44rem;
        }
    }

}

</style>



// WEBPACK FOOTER //
// src/components/shootShop/rule.vue